import { recentActivitiesQuery } from '@atlassian/dynamic-cards-search-client';

import { type SearchLinkProps } from '../../../common/ui/search-link';
import { filterSearchResults } from '../../../common/utils/filter-search-results';
import { type onError } from '../../error-boundary';

import { recentViewsResultMapper } from './recent-views-result-mapper';

export const prefetchRecentViewsResults = async (cloudId: string, onError: onError): Promise<SearchLinkProps[]> => {
	const fetchData = async (
		filteredProducts: string[],
		filteredObjectTypes: string[],
		filteredRootContainerIds: string[],
		itemsLimit: number,
	) => {
		const response = await recentActivitiesQuery({
			variables: {
				filteredProducts,
				filteredObjectTypes,
				filteredRootContainerIds,
				itemsLimit,
			},
		}).catch((error) => {
			onError(error);
		});

		const data = response && response.data;

		const edges = data?.activity?.myActivity?.all?.edges || [];
		return edges?.map((edge) => recentViewsResultMapper(edge));
	};

	return await fetchData(
		['confluence', 'jira', 'townsquare'],
		['page', 'issue', 'project'],
		[`ari:cloud:platform::site/${cloudId}`, `ari:cloud:townsquare::site/${cloudId}`],
		200,
	);
};

export const filterRecentViewsResults = (recentViews: SearchLinkProps[], inputQuery: string): SearchLinkProps[] => {
	if (inputQuery.length === 0) {
		return recentViews;
	}
	return recentViews && filterSearchResults(recentViews, inputQuery);
};
